export const SERVICE_OVERDUE_MESSAGE =
  'Required maintenance is overdue. This unit is unavailable for operator use.';

export const isOperatorUseBlocked = (forklift) => forklift?.operatorUseBlocked === true;

export const getForkliftMakeModel = (forklift) => {
  const parts = [forklift?.make, forklift?.model]
    .map((part) => String(part || '').trim())
    .filter(Boolean);
  return parts.length ? parts.join(' / ') : 'Make / model not available';
};

export const getForkliftSerialNumber = (forklift) => {
  const serial = String(forklift?.serialNumber || '').trim();
  return serial || 'Serial not available';
};

export const matchesForkliftSearch = (forklift, searchTerm) => {
  const q = String(searchTerm || '').trim().toLowerCase();
  if (!q) return true;

  return [forklift?.unitId, forklift?.make, forklift?.model, forklift?.serialNumber]
    .map((value) => String(value || '').toLowerCase())
    .some((value) => value.includes(q));
};

export const isActiveForklift = (forklift) =>
  String(forklift?.status || '').toUpperCase() !== 'RETIRED';
